const BlockView = require('views/block/base-block-view');
const utils = require('lib/utils');
const SizingService = require('services/sizing-service');

let LayoutView = BlockView.extend({
  className: 'layout',
  initialize: function () {
    this.model.set('cid', this.model.cid);
    var path = this.model.get('path');
    var customTemplate = `components/layouts/${path}`;
    this.model.set('customTemplate', customTemplate);
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function () {
    if (this.model.has('regions')) {
      this.model.get('regions').forEach((region, idx) => {
        const $region = this.$el.find(`[data-region='${this.model.get('cid')}-region${idx}']`);

        if (region.blocks) {
          this.renderNestedBlocks(`${this.model.get('cid')}-region${idx}`, region.blocks);
        }

        if (region.disablePadding) {
          $region.addClass('disablePadding');
        }

        if (region.disableMargin) {
          $region.addClass('disableMargin');
        }

        if (region.background) {
          const params = region.background;

          $region.addClass('has-bg');

          switch (params.type) {
            case 'gradient':
              const direction = params.settings.direction || 'to bottom';
              const gradient = `linear-gradient(${direction}, ${params.settings.first}, ${params.settings.second})`;

              $region.css('background-image', gradient);
              if (params.settings.color) {
                $region.css('background-color', params.settings.color);
              }

              break;
            case 'image':
              let customization = null;
              let backgroundImage = null;

              if (params.settings.custom_background_image_slug) {
                customization = EF.customizations.getByKeyAndSlug(
                  'image-content-customization',
                  params.settings.custom_background_image_slug
                );
              }

              //Assuming the customization URL is absolute
              backgroundImage = customization
                ? `url(${customization.url})`
                : `url(${utils.coursePath(params.settings.path)})`;
              $region.css('background-image', backgroundImage);

              break;
            case 'color':
              $region.css('background-color', params.settings.color);
              break;
            default:
              break;
          }

          if (params.settings.position) {
            $region.css('background-position', params.settings.position);
          }
        }

        if (region.minHeight) {
          Chaplin.mediator.subscribe('page:state:loaded', () => {
            SizingService.setMinHeight($region, region.minHeight);
            $(window).on('resize', () => {
              SizingService.setMinHeight($region, region.minHeight);
            });
          });
        }
      });
    }
  },
  play: function () {
    this.readyToGo();
  },
});

module.exports = LayoutView;
